import {
  BROADCAST_KNOCK_MEETING,
  BROADCAST_SET_PRESENTER_DISMISSED
} from 'actions/Types';

function isPresenterDismissed(state = false, action) {
  if (action.type === `${BROADCAST_SET_PRESENTER_DISMISSED}`) {
    return action.payload;
  }

  if (action.type === `${BROADCAST_KNOCK_MEETING}`) {
    return false;
  }

  return state;
}

export default isPresenterDismissed;
